<template>
  <div class="fh-card p-6">
    <slot name="header" />

    <div class="grid grid-cols-1 gap-6 md:grid-cols-[0.45fr_1.55fr]">
      <div>
        <slot name="master" />
      </div>
      <div class="md:border-line md:border-l md:pl-6">
        <slot name="detail" />
      </div>
    </div>
  </div>
</template>
